module.exports = __webpack_public_path__ + "images/emoji/sa.06ad81b790dba2fe499b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sa.png
// module id = F9xU
// module chunks = 24